import { GAME_APP_LOCAL_STORAGE_KEY } from 'App/constants';
import { environment } from 'App/Helpers';
import { getLocaleRuntimeFields } from 'App/Services/Localizations/localeSettings';

import localeSettings from '../localization/settings.json';

import { adStaticConfig } from './ads';

export * from './ads';
export * from './ga.js';

export const STORAGE_KEY = GAME_APP_LOCAL_STORAGE_KEY;

/* global __LP_CONFIG__ */
/** Runtime config: build-time slice from buildEnv.json plus live fields. */
export const config = {
    ...__LP_CONFIG__,
    ...getLocaleRuntimeFields(localeSettings, {
        includeManifestUrls: true,
        pushCampaignConfig: __LP_CONFIG__.pushCampaignConfig,
    }),
    frontVersion: __BUILD_NUMBER__,
    env: environment(),
    adStaticConfig,
};
